import { createStaticMapsUrl } from '@vis.gl/react-google-maps'

import {
  GOOGLE_MAP_API_PROVIDER_KEY,
  GOOGLE_MAP_CENTER,
  GOOGLE_MAP_ID,
} from '../GoogleMap'

import {
  GOOGLE_STATIC_MAP_HEIGHT,
  GOOGLE_STATIC_MAP_SCALE,
  GOOGLE_STATIC_MAP_WIDTH,
  GOOGLE_STATIC_MAP_ZOOM,
} from './GoogleStaticMap.constants'

function GoogleStaticMap({
  className,
  height = GOOGLE_STATIC_MAP_HEIGHT,
  isMarker,
  language,
  lat,
  lng,
  mapCenter = GOOGLE_MAP_CENTER,
  scale = GOOGLE_STATIC_MAP_SCALE,
  width = GOOGLE_STATIC_MAP_WIDTH,
  zoom = GOOGLE_STATIC_MAP_ZOOM,
}) {
  const previewMap = createStaticMapsUrl({
    apiKey: GOOGLE_MAP_API_PROVIDER_KEY,
    center: lat && lng ? { lat, lng } : mapCenter,
    height,
    language,
    mapId: GOOGLE_MAP_ID,
    markers: isMarker ? [{ color: 'red', location: { lat, lng } }] : [],
    scale,
    width,
    zoom,
  })

  return <img alt='' className={className} src={previewMap} />
}

export default GoogleStaticMap
